module.exports = __webpack_public_path__ + "img/new_logo.30c8fa4c.png";